// test188
(188 && 0);
